export default function LoadingCard(): JSX.Element {
  return (
    <div className="mt-6 flex h-52 flex-col items-center justify-center space-y-4 rounded-3xl bg-gradient-to-br from-blue-400 to-pink-500 px-5 text-white shadow-md">
      <p className="text-5xl font-semibold">Loading...</p>
    </div>
  );
}
